import { Component } from '@angular/core';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';
import { RouterLink, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-metrics',
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.scss'],
  imports: [PayeeButtonComponent, RouterLink, RouterOutlet],
})
export class MetricsComponent {}
